/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'
import moment from 'jalali-moment'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [banners, setBanners] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setBanners(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>تعداد بنر</th>
            <th>وضعیت</th>
            <th>تاریخ ایجاد</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {banners ? banners.map(item => (
              <tr key={item._id}>
                <td>جایگاه بنرها</td>
                <td>{item.banners.length}</td>
                <td>{item.status ? 'فعال' : 'غیرفعال'}</td>
                <td>{moment(item.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</td>
                <td>
                  <button onClick={() => navigate(`/im/banners/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
